import React from "react";
import LegalPage from "./Legal";

const DATA = {
  tr: {
    title: "Gizlilik Politikası",
    updated: "Son güncelleme: Haziran 2026",
    intro:
      "AdalCrea olarak kişisel verilerinizin güvenliğine büyük önem veriyoruz. Bu Gizlilik Politikası, adalcrea.com web sitesini ziyaret ettiğinizde veya hizmetlerimizden yararlandığınızda verilerinizin nasıl toplandığını, kullanıldığını ve korunduğunu açıklar.",
    sections: [
      {
        heading: "Topladığımız Bilgiler",
        body: ["Sizinle iletişim kurabilmek ve hizmet sunabilmek için aşağıdaki bilgileri toplayabiliriz:"],
        list: [
          "İletişim formu aracılığıyla paylaştığınız ad, soyad, e-posta adresi, telefon numarası ve şirket bilgileri.",
          "Web sitesi kullanımına ilişkin çerezler ve analitik veriler (ziyaret edilen sayfalar, tarayıcı türü, IP adresi).",
          "Bültenimize abone olmanız durumunda e-posta adresiniz.",
        ],
      },
      {
        heading: "Bilgilerin Kullanım Amacı",
        body: ["Topladığımız kişisel verileri yalnızca aşağıdaki amaçlarla kullanırız:"],
        list: [
          "Talep ve sorularınıza yanıt vermek, hizmet tekliflerimizi sunmak.",
          "Sözleşme ve hizmet süreçlerini yürütmek.",
          "Web sitemizi ve hizmetlerimizi iyileştirmek.",
          "Onay vermeniz halinde, size bilgilendirme ve pazarlama içerikleri göndermek.",
        ],
      },
      {
        heading: "Bilgilerin Paylaşımı",
        body: [
          "Kişisel bilgileriniz yalnızca sizinle iletişim kurmak ve talep ettiğiniz hizmeti sunmak amacıyla kullanılır. Bilgileriniz, yasal zorunluluklar dışında üçüncü taraflarla pazarlama amacıyla paylaşılmaz veya satılmaz.",
          "Hizmetlerimizi sunarken kullandığımız güvenilir altyapı sağlayıcıları (örneğin bulut ve e-posta hizmetleri) yalnızca hizmetin gerektirdiği ölçüde verilere erişebilir ve gizlilik yükümlülüklerine tabidir.",
        ],
      },
      {
        heading: "Çerezler",
        body: [
          "Web sitemiz, kullanıcı deneyimini iyileştirmek ve trafiği analiz etmek için çerezler kullanabilir. Tarayıcı ayarlarınızdan çerezleri dilediğiniz zaman yönetebilir veya devre dışı bırakabilirsiniz.",
        ],
      },
      {
        heading: "Veri Güvenliği",
        body: [
          "Kişisel verilerinizi yetkisiz erişime, kayba veya kötüye kullanıma karşı korumak için uygun teknik ve idari güvenlik önlemleri uygularız.",
        ],
      },
      {
        heading: "KVKK Kapsamındaki Haklarınız",
        body: [
          "6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) uyarınca; verilerinizin işlenip işlenmediğini öğrenme, düzeltilmesini veya silinmesini talep etme, işlemeye itiraz etme ve verilerinize erişim haklarına sahipsiniz. Bu haklarınızı kullanmak için bizimle iletişime geçebilirsiniz.",
        ],
      },
    ],
    contactNote:
      "Bu Gizlilik Politikası ile ilgili sorularınız için info@adalcrea.com.tr adresinden veya 0543 804 70 05 numaralı telefondan bize ulaşabilirsiniz.",
  },
  en: {
    title: "Privacy Policy",
    updated: "Last updated: June 2026",
    intro:
      "At AdalCrea, we place great importance on the security of your personal data. This Privacy Policy explains how your data is collected, used and protected when you visit adalcrea.com or use our services.",
    sections: [
      {
        heading: "Information We Collect",
        body: ["We may collect the following information in order to contact you and provide our services:"],
        list: [
          "Name, email address, phone number and company details you share through the contact form.",
          "Cookies and analytics data related to website usage (pages visited, browser type, IP address).",
          "Your email address if you subscribe to our newsletter.",
        ],
      },
      {
        heading: "How We Use Information",
        body: ["We use the personal data we collect only for the following purposes:"],
        list: [
          "To respond to your requests and questions and present our service offerings.",
          "To carry out contract and service processes.",
          "To improve our website and services.",
          "To send you informational and marketing content, if you have consented.",
        ],
      },
      {
        heading: "Sharing of Information",
        body: [
          "Your personal information is used solely to contact you and provide the service you request. Except where legally required, your data is never shared with or sold to third parties for marketing purposes.",
          "Trusted infrastructure providers we use to deliver our services (such as cloud and email services) may access data only to the extent necessary and are bound by confidentiality obligations.",
        ],
      },
      {
        heading: "Cookies",
        body: [
          "Our website may use cookies to improve user experience and analyze traffic. You can manage or disable cookies at any time through your browser settings.",
        ],
      },
      {
        heading: "Data Security",
        body: [
          "We apply appropriate technical and administrative security measures to protect your personal data against unauthorized access, loss or misuse.",
        ],
      },
      {
        heading: "Your Rights",
        body: [
          "Under applicable data protection legislation (including the Turkish KVKK and GDPR), you have the right to learn whether your data is being processed, to request its correction or deletion, to object to processing, and to access your data. You may contact us to exercise these rights.",
        ],
      },
    ],
    contactNote:
      "For questions about this Privacy Policy, you can reach us at info@adalcrea.com.tr or by calling 0543 804 70 05.",
  },
};

const Privacy = () => <LegalPage data={DATA} path="/gizlilik" />;

export default Privacy;
